(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initProductListQuickActions(root) {
      var modal = root.querySelector('[data-quick-view-modal]');
      var wishlistKey = 'shopify_wishlist';
      var wishlistUrl = root.getAttribute('data-wishlist-url') || '/pages/wish-list';

      function getWishlist() {
        try {
          return JSON.parse(localStorage.getItem(wishlistKey)) || [];
        } catch (e) {
          return [];
        }
      }

      function saveWishlist(list) {
        localStorage.setItem(wishlistKey, JSON.stringify(list));
      }

      function markActiveWishlistButtons() {
        var wishlist = getWishlist();
        root.querySelectorAll('[data-wishlist-btn]').forEach(function (btn) {
          var id = btn.getAttribute('data-product-id');
          var found = wishlist.some(function (item) {
            return String(item.id) === String(id);
          });
          btn.classList.toggle('is-active', found);
        });
      }

      root.addEventListener('click', function (event) {
        var wishlistBtn = event.target.closest('[data-wishlist-btn]');
        if (wishlistBtn) {
          var wishlist = getWishlist();
          var id = wishlistBtn.getAttribute('data-product-id');
          var exists = wishlist.some(function (item) {
            return String(item.id) === String(id);
          });

          if (!exists) {
            wishlist.push({
              id: id,
              handle: wishlistBtn.getAttribute('data-product-handle'),
              title: wishlistBtn.getAttribute('data-product-title'),
              image: wishlistBtn.getAttribute('data-product-image')
            });
            saveWishlist(wishlist);
          }

          window.location.href = wishlistUrl;
          return;
        }

        var quickViewBtn = event.target.closest('[data-quick-view-btn]');
        if (quickViewBtn && modal) {
          openQuickView(quickViewBtn.getAttribute('data-product-handle'));
        }

        if (event.target.closest('[data-quick-view-close]') && modal) {
          closeQuickView();
        }
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && modal && !modal.hidden) {
          closeQuickView();
        }
      });

      function openQuickView(handle) {
        if (!handle) return;
        var body = modal.querySelector('[data-quick-view-body]');
        body.innerHTML = '<div class="quick-view-modal__loading">' + 'Loading...' + '</div>';
        modal.hidden = false;
        document.body.style.overflow = 'hidden';

        fetch('/products/' + handle + '.js')
          .then(function (res) {
            return res.json();
          })
          .then(function (product) {
            renderQuickView(product, body);
          })
          .catch(function () {
            body.innerHTML = '<p>Unable to load product.</p>';
          });
      }

      function closeQuickView() {
        modal.hidden = true;
        document.body.style.overflow = '';
      }

      function escapeHtml(value) {
        var div = document.createElement('div');
        div.textContent = value == null ? '' : String(value);
        return div.innerHTML;
      }

      function findVariantByOptionValues(product, values) {
        return product.variants.find(function (variant) {
          return variant.options.every(function (value, index) {
            return value === values[index];
          });
        });
      }

      function renderQuickView(product, body) {
        var images = product.images && product.images.length ? product.images : [product.featured_image];
        var firstVariant = product.variants[0];
        var selectedValues = firstVariant.options.slice();

        // Thumbnails
        var thumbsHtml = images.length > 1
          ? '<div class="quick-view-modal__thumbs">' +
            images
              .map(function (img, i) {
                return (
                  '<button type="button" class="quick-view-modal__thumb' +
                  (i === 0 ? ' is-active' : '') +
                  '" data-thumb data-image="' + img + '">' +
                  '<img src="' + img + '" alt="">' +
                  '</button>'
                );
              })
              .join('') +
            '</div>'
          : '';

        // One <select> per option (Size, Color, etc.)
        // Remove variant selector permanently
        var optionsHtml = '';

        var comparePriceHtml = firstVariant.compare_at_price > firstVariant.price
          ? '<span class="quick-view-modal__compare-price" data-quick-view-compare-price>' +
            formatMoney(firstVariant.compare_at_price) + '</span>'
          : '';

        body.innerHTML =
          '<div class="quick-view-modal__media">' +
          '<img data-main-image src="' + (images[0] || '') + '" alt="' + escapeHtml(product.title) + '">' +
          thumbsHtml +
          '</div>' +
          '<div class="quick-view-modal__details">' +
          (product.vendor ? '<div class="quick-view-modal__vendor">' + escapeHtml(product.vendor) + '</div>' : '') +
          '<h2 class="quick-view-modal__title">' + escapeHtml(product.title) + '</h2>' +
          '<div class="quick-view-modal__price">' +
          '<span data-quick-view-price>' + formatMoney(firstVariant.price) + '</span>' +
          comparePriceHtml +
          '</div>' +
          '<div class="quick-view-modal__sku" data-quick-view-sku>' +
          (firstVariant.sku ? 'SKU: ' + escapeHtml(firstVariant.sku) : '') +
          '</div>' +
          '<div class="quick-view-modal__availability" data-quick-view-availability>' +
          (firstVariant.available ? 'In stock' : 'Sold out') +
          '</div>' +
          optionsHtml +
          '<div class="quick-view-modal__quantity">' +
          '<label>Quantity</label>' +
          '<input type="number" min="1" value="1" data-quantity-input>' +
          '</div>' +
          '<button type="button" class="quick-view-modal__add-to-cart" data-add-to-cart-btn data-variant-id="' +
          firstVariant.id +
          '"' +
          (firstVariant.available ? '' : ' disabled') +
          '>' +
          (firstVariant.available ? 'Add to cart' : 'Sold out') +
          '</button>' +
          '<div class="quick-view-modal__add-to-cart-message" data-add-to-cart-message></div>' +
          (product.description
            ? '<div class="quick-view-modal__description">' + product.description + '</div>'
            : '') +
          '<a class="quick-view-modal__view-full-link" href="/products/' +
          product.handle +
          '">View full details</a>' +
          '</div>';

        var mainImage = body.querySelector('[data-main-image]');
        var thumbs = body.querySelectorAll('[data-thumb]');
        var optionSelects = body.querySelectorAll('[data-option-select]');
        var addBtn = body.querySelector('[data-add-to-cart-btn]');
        var priceEl = body.querySelector('[data-quick-view-price]');
        var skuEl = body.querySelector('[data-quick-view-sku]');
        var availabilityEl = body.querySelector('[data-quick-view-availability]');
        var quantityInput = body.querySelector('[data-quantity-input]');
        var messageEl = body.querySelector('[data-add-to-cart-message]');

        thumbs.forEach(function (thumb) {
          thumb.addEventListener('click', function () {
            mainImage.src = thumb.getAttribute('data-image');
            thumbs.forEach(function (t) {
              t.classList.remove('is-active');
            });
            thumb.classList.add('is-active');
          });
        });

        function updateSelectedVariant() {
          var values = [];
          optionSelects.forEach(function (select) {
            values[Number(select.getAttribute('data-option-index'))] = select.value;
          });
          var variant = findVariantByOptionValues(product, values);
          if (!variant) return;

          addBtn.setAttribute('data-variant-id', variant.id);
          addBtn.disabled = !variant.available;
          addBtn.textContent = variant.available ? 'Add to cart' : 'Sold out';
          priceEl.textContent = formatMoney(variant.price);
          skuEl.textContent = variant.sku ? 'SKU: ' + variant.sku : '';
          availabilityEl.textContent = variant.available ? 'In stock' : 'Sold out';

          if (variant.featured_image && variant.featured_image.src) {
            mainImage.src = variant.featured_image.src;
          }
        }

        optionSelects.forEach(function (select) {
          select.addEventListener('change', updateSelectedVariant);
        });

        addBtn.addEventListener('click', function () {
          var variantId = addBtn.getAttribute('data-variant-id');
          var quantity = Math.max(1, parseInt(quantityInput.value, 10) || 1);
          addBtn.disabled = true;
          addBtn.textContent = 'Adding...';
          messageEl.textContent = '';

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: quantity })
          })
            .then(function (res) {
              if (!res.ok) {
                return res.json().then(function (err) {
                  throw new Error(err.description || 'Could not add to cart');
                });
              }
              return res.json();
            })
            .then(function () {
              addBtn.textContent = 'Added! Redirecting to cart...';
              document.dispatchEvent(new CustomEvent('cart:updated'));
              setTimeout(function () {
                window.location.href = '/cart';
              }, 600);
            })
            .catch(function (err) {
              addBtn.disabled = false;
              addBtn.textContent = 'Add to cart';
              messageEl.textContent = err.message || 'Something went wrong. Please try again.';
            });
        });
      }

      function formatMoney(cents) {
        return (cents / 100).toFixed(2);
      }

      markActiveWishlistButtons();
    }

    document.querySelectorAll('[data-testid="product-list"]').forEach(function (root) {
      initProductListQuickActions(root);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
